import ageLevelIcon from 'images/ageLevel.svg';
import languageIcon from 'images/language.svg';
import videoGreen from 'images/videoGreen.svg';
import classVersionIcon from 'images/class.svg';
import cohortUsers from 'images/cohortUsrs.svg';
import calendarGreen from 'images/calendarGreen.svg';
import { useNavigate } from 'react-router-dom';
import RoutesHelper from 'helpers/routes';
import { Button } from '@teachstonellc/component-library';
import {
  ArrowLeft,
  Printer,
  Download
} from '@teachstonellc/component-library/dist/icons';

export interface CalibrationTopSectionProps {
  title: string;
  userName: string;
  classVersion: string;
  ageLevel: string;
  videoTitle: string;
  language: string;
  dateRange: string;
  onPrint: () => void;
  onDownloadCSV?: () => void;
}

function CalibrationTopSection(props: CalibrationTopSectionProps) {
  const {
    title,
    userName,
    classVersion,
    ageLevel,
    videoTitle,
    language,
    dateRange,
    onPrint,
    onDownloadCSV
  } = props;
  const navigate = useNavigate();

  function handleBack() {
    navigate(RoutesHelper.getPath('admin-cohort-calibrations'));
  }

  return (
    <div className="PrintBackgroundColor rounded-t-2xl px-4 py-6 md:px-10 md:py-8 mx-auto bg-[#F9F9F9] mb-0 p-1 sm:px-8 sm:py-6 lg:px-20 lg:py-6 lg:mx-12">
      <div className="bg-white rounded-2xl px-8 py-6">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight text-gray-900">
            {title}
          </h1>
          <div className="flex gap-2">
            <div className="mr-4">
              <Button
                onClick={handleBack}
                key="back"
                type="button"
                variant="secondary"
                startIcon={ArrowLeft}
              >
                Back
              </Button>
            </div>

            {onDownloadCSV && (
              <Button
                onClick={onDownloadCSV}
                type="button"
                variant="ghost"
                startIcon={Download}
              >
                Download CSV
              </Button>
            )}
            <Button
              onClick={onPrint}
              type="button"
              variant="ghost"
              startIcon={Printer}
              className="print:hidden"
            >
              Print
            </Button>
          </div>
        </div>
        <div className="flex items-center gap-3 mt-2 mb-3 flex-wrap">
          <span className="inline-flex items-center gap-2">
            <img src={cohortUsers} className=" inline-block" alt="" />
            {(userName || '').toUpperCase()}
          </span>
        </div>
        <hr className="my-4 border-gray-200" />
        <div className="flex flex-wrap items-center gap-6 text-base font-semibold text-gray-700">
          <span className="inline-flex items-center gap-2">
            <img
              src={classVersionIcon}
              className="inline-block"
              alt={`${classVersion}`}
            />
            {classVersion}
          </span>
          <span className="inline-flex items-center gap-2">
            <img
              src={ageLevelIcon}
              className="inline-block"
              alt={`${ageLevel}`}
            />
            {ageLevel}
          </span>
          <span className="inline-flex items-center gap-2">
            <img
              src={videoGreen}
              className="inline-block"
              alt={`${videoTitle}`}
            />
            {videoTitle}
          </span>
          <span className="inline-flex items-center gap-2">
            <img
              src={languageIcon}
              className="inline-block"
              alt={`${language}`}
            />
            {language}
          </span>
          <span className="inline-flex items-center gap-2">
            <img src={calendarGreen} className="inline-block" alt="" />
            {dateRange}
          </span>
        </div>
      </div>
    </div>
  );
}

export default CalibrationTopSection;
